import Import from './src/import.vue'
import { withInstall } from '@touchvue/utils'

export const ToImport = withInstall(Import)
